@if (
  {
    ort: ort$ | async,
    bundesland: selectedBundesland$ | async,
    suchwort: suchwort$ | async,
    bezeichnung: bezeichnung$ | async,
    correction: correction$ | async,
    removedToken: removedToken$ | async,
    pageInfos: (pageInfos$ | async)!,
    hasMoreHits: (hasMoreHits$ | async),
    bildungsangeboteLoading: bildungsangeboteLoading$ | async,
    showRequiredInputState: showRequiredInputState$ | async
  };
  as context
) {
  <div class="hits-card now-decorative-card now-decorative-card-small">
    @if (
      context.bildungsangeboteLoading === false &&
      context.pageInfos?.totalResults !== 0 &&
      context.showRequiredInputState === false
    ) {
      @if (context.removedToken) {
        <div>
          Ihre Suche nach <span class="fw-bold">{{ context.suchwort }}</span> ergab leider keine
          Ergebnisse.
        </div>
      }
      <div id="ergebniszaehler">
        <span id="ergebniszaehler_text" role="alert">
          <span class="suche-lib-ergebniszaehler">
            @if (context.hasMoreHits) {
              mehr als
            }
            <span class="visually-hidden">{{ context.pageInfos.totalResults }}</span
            ><span aria-hidden="true" class="fw-bold">{{
              context.pageInfos.totalResults | number
            }}</span></span
          >
          {{
            context.pageInfos.totalResults
              | i18nPlural: { '=1': 'Weiterbildungsangebot', other: 'Weiterbildungsangebote' }
          }}
          @if (context.suchwort !== '' || context.bezeichnung !== '') {
            <span [innerHtml]="ergebnisZaehlerText$ | async"> </span>
          }
          @if (context.ort) {
            <span>
              in <span class="fw-bold"> {{ context.ort.name }} </span>
            </span>
          }
          @if (context.bundesland) {
            <span>
              in <span class="fw-bold"> {{ context.bundesland }} </span>
            </span>
          }
          gefunden.
        </span>
      </div>
      @if (context.correction) {
        <div id="correction">
          <span>Stattdessen suchen nach: </span>
          <button class="original_suchwort" (click)="triggerSearchWithoutCorrection()">
            {{ context.suchwort }}
          </button>
        </div>
      }
    }

    @if (isNowWbSuche) {
      <hr />
      @if (favoriteEntity$ | async; as favoriteEntity) {
        <now-wbsuche-lib-favorit-toggle
          [entity]="favoriteEntity"
          class="text-center"
        ></now-wbsuche-lib-favorit-toggle>
      }
    }
  </div>
}
